import { FormikHandlers } from 'formik'
import React from 'react'

interface SelectDropdownProps {
  additionalContainerClasses?: string
  defaultValue?: string
  disabled?: boolean
  error?: string
  font?: string
  handleBlur: FormikHandlers['handleBlur']
  handleChange: FormikHandlers['handleChange']
  id?: string
  labelText: string
  marginBottom?: string
  name?: string
  options: { text: string; value: string }[]
  placeholder: string
  required?: boolean
  showDefaultOption?: boolean
  touched?: boolean
  value: string
  width?: string
}

const SelectDropdown: React.FC<SelectDropdownProps> = ({
  additionalContainerClasses = '',
  disabled,
  error,
  font,
  handleBlur,
  handleChange,
  id,
  labelText,
  marginBottom = 'mb-2',
  name,
  options,
  placeholder = 'Select',
  required,
  showDefaultOption = false,
  touched,
  value,
  width = 'w-full',
}) => {
  return (
    <div
      className={`${additionalContainerClasses} ${width} flex flex-col ${marginBottom}`}
    >
      <label
        htmlFor={id ? id : undefined}
        className={`text-sm text-gray-copy mb-[6px] ${font ? font : ''}`}
      >
        {labelText} {required && <span className="">*</span>}{' '}
      </label>
      <select
        aria-describedby={`${id}_hint`}
        aria-invalid={error ? 'true' : 'false'}
        name={name ? name : undefined}
        id={id ? id : undefined}
        value={value}
        disabled={disabled}
        onBlur={handleBlur}
        onChange={handleChange}
        className="rounded-md border border-[#BDBDBD] focus:outline-none focus:ring-2 focus:ring-nptDGreen focus:ring-offset-2 transition-all duration-300 text-sm"
      >
        <option
          value=""
          disabled={showDefaultOption}
          hidden={!showDefaultOption}
        >
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>

      {touched && error && (
        <p
          id={id ? `${id}_hint` : undefined}
          className={`${
            !error ? 'hidden opacity-0' : 'opacity-100'
          } flex max-w-[270px] h-3 mt-1 text-xs text-red-brand`}
        >
          {error}
        </p>
      )}
    </div>
  )
}

export default SelectDropdown
